import { render, staticRenderFns } from "./QuoteTemplateListSideMenu.vue?vue&type=template&id=2001c0a7"
import script from "./QuoteTemplateListSideMenu.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2001c0a7')) {
      api.createRecord('2001c0a7', component.options)
    } else {
      api.reload('2001c0a7', component.options)
    }
    module.hot.accept("./QuoteTemplateListSideMenu.vue?vue&type=template&id=2001c0a7", function () {
      api.rerender('2001c0a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateListSideMenu.vue"
export default component.exports